// extracted by mini-css-extract-plugin
module.exports = {"menu":"_2DpAT"};